import React from 'react';
import { Button } from '@mui/material';
import T from 'prop-types';
import { useTranslation } from 'react-i18next';
import { NotifyTypo } from 'web-components';
import { StyledContent, StyledHandlers, StyledNewDialog } from '../elements';

const labelAmend = 'machines.detail.auto_config.modal';

const ApproveAutoConfigModal = ({ open, handleClose, handleSubmit }) => {
  const { t } = useTranslation();

  const actionBar = (
    <StyledHandlers>
      <Button color="secondary" onClick={() => handleClose()}>
        {t(`${labelAmend}.cancel`)}
      </Button>
      <Button
        variant="contained"
        data-selector="approve-modal-submit"
        style={{ padding: '1rem 2.5rem' }}
        color="primary"
        onClick={handleSubmit}
      >
        {t(`${labelAmend}.approve`)}
      </Button>
    </StyledHandlers>
  );

  return (
    <StyledNewDialog
      open={open}
      handleClose={(event, reason) => {
        if (reason && reason === 'backdropClick') return;
        handleClose();
      }}
      title={t(`${labelAmend}.title`)}
      subTitle={t(`${labelAmend}.subtitle`)}
      displayActionBar="true"
      actionBar={actionBar}
      maxWidth="680px"
      content={
        <StyledContent>
          <NotifyTypo.Heading2>{t(`${labelAmend}.content`)}</NotifyTypo.Heading2>
        </StyledContent>
      }
    />
  );
};

ApproveAutoConfigModal.propTypes = {
  open: T.bool.isRequired,
  handleClose: T.func.isRequired,
  handleSubmit: T.func.isRequired
};

export default ApproveAutoConfigModal;
